"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumPhoneNumberVerificationStatusesEnum = void 0;
var EnumPhoneNumberVerificationStatusesEnum;
(function (EnumPhoneNumberVerificationStatusesEnum) {
    EnumPhoneNumberVerificationStatusesEnum["Unverified"] = "unverified";
    EnumPhoneNumberVerificationStatusesEnum["Verified"] = "verified";
})(EnumPhoneNumberVerificationStatusesEnum = exports.EnumPhoneNumberVerificationStatusesEnum || (exports.EnumPhoneNumberVerificationStatusesEnum = {}));
//# sourceMappingURL=phoneNumberVerificationStatuses.js.map